export default "__VITE_ASSET__B_u5PFHs__"